import { render } from "./AboutUsContentThree.vue?vue&type=template&id=9f83034c"
import script from "./AboutUsContentThree.vue?vue&type=script&lang=js"
export * from "./AboutUsContentThree.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/tre/tre/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__